import React, { useState, useEffect } from "react";
import api from "../lib/axios";
import PickDate from "../components/Pick_a_date";
import PersonalInfo from "../components/Personal_info";
import ReviewOrder from "../components/Review_order";
import Header from "../components/Header";
import CountdownTimer from "../components/CountdownTimer";

export default function Booking() {
  const [startTimerFlag, setStartTimerFlag] = useState(false);
  const [initialSeconds, setInitialSeconds] = useState(0);
  const [formstep, setFormStep] = useState(1);
  const [formdata, setFormData] = useState([]);
  const [classInProgress, setClassInProgress] = useState("");
  // Go back to prev step
  const prevStep = () => {
    console.log(
      "Back Clicked | Current Step : " + (formstep + 1),
      formdata
    );
    setFormStep(formstep - 1);
    ChangeStepCss(formstep - 1);
  };

  // Proceed to next step
  const nextStep = () => {
    if (formdata.expiry_secs > 0 && !startTimerFlag) {
      let secs = parseInt(formdata.expiry_secs);
      setInitialSeconds(secs);
      setStartTimerFlag(true);
    }
    console.log(
      "Next Clicked | Current Step : " + (formstep + 1), formdata
    );
    setFormStep(formstep + 1);
    ChangeStepCss(formstep + 1);
  };

  const updateReservationSecs = (expiry_secs) => {
    console.log('updateReservationSecs', expiry_secs);
    setInitialSeconds(expiry_secs);
    setStartTimerFlag(true);
  };

  const ChangeStepCss = (formstep) => {
    switch (formstep) {
      case 1:
        setClassInProgress("");
        break;
      case 2:
        setClassInProgress("personal_info");
        break;
      case 3:
        setClassInProgress("review_info");
        break;
    }
  };

  /*console.log(formstep);*/

  useEffect(() => {
    // Mint a server-issued signed reservation JWT on first visit. This is
    // the SOLE proof-of-ownership for the reservation now — the backend no
    // longer accepts the old client-generated raw `u_b_id` strings (they
    // were the back door that made the signed-token machinery cosmetic).
    // The token is short-lived (15 min) — we refresh on each booking page
    // mount.
    (async () => {
      try {
        const res = await api.post("reservation/token", {});
        const token = res && res.data && res.data.token_result && res.data.token_result.token;
        if (token) {
          localStorage.setItem("u_b_id_jwt", token);
          // Also clear any stale legacy id from older builds so call sites
          // can't accidentally fall back to a value the server now rejects.
          localStorage.removeItem("u_b_id");
        }
      } catch (err) {
        console.warn("reservation token mint failed", err && err.message);
      }
    })();
  }, []);


  return (
    <>
      <Header />
      <div className="grid grid-cols-1 booking-nav-col">
        <div
          className={
            "flex md:pt-[40px] md:pb-[15px] booking-nav " + classInProgress
          }
        >
          <div className="w-4/12 md:w-1/6 place-items-center p-2">
            <p
              className={
                "md:text-[18px] text-[16px] font-medium text-center cursor-pointer " +
                (formstep >= 1 ? " text-[#17ba17]" : "")
              }
            >
              Pick Date &amp; Time
            </p>
          </div>
          <div className="w-4/12 md:w-1/6 place-items-center p-2">
            <p
              className={
                "md:text-[18px] text-[16px] font-medium text-center cursor-pointer " +
                (formstep >= 2 ? " text-[#17ba17]" : "")
              }
            >
              Personal Info
            </p>
          </div>
          <div className="w-4/12 md:w-1/6 place-items-center p-2">
            <p
              className={
                "md:text-[18px] text-[16px] font-medium text-center cursor-pointer " +
                (formstep >= 3 ? " text-[#17ba17]" : "")
              }
            >
              Payment Info
            </p>
          </div>
        </div>
      </div>
      {startTimerFlag && <CountdownTimer startTimerFlag={startTimerFlag} initialSeconds={initialSeconds} values={formdata} updateReservationSecs={updateReservationSecs}></CountdownTimer>}
      {renderSwitch(formstep, prevStep, nextStep, formdata, setFormData)}
    </>
  );
}

function renderSwitch(formstep, prevStep, nextStep, formdata, setFormData) {
  switch (formstep) {
    case 1:
      return (
        <PickDate
          nextStep={nextStep}
          values={formdata}
          setFormData={setFormData}
        />
      );
    case 2:
      return (
        <PersonalInfo
          nextStep={nextStep}
          prevStep={prevStep}
          values={formdata}
          setFormData={setFormData}
        />
      );
    case 3:
      return (
        <ReviewOrder
          prevStep={prevStep}
          values={formdata}
          setFormData={setFormData}
        />
      );
    default:
      console.log("Form cannot perform any action try after sometime.");
  }
}
